export default "__VITE_ASSET__BGhziLjm__"